import { render, staticRenderFns } from "./CallFeaturesPanel.vue?vue&type=template&id=2012de22&"
import script from "./CallFeaturesPanel.vue?vue&type=script&lang=js&"
export * from "./CallFeaturesPanel.vue?vue&type=script&lang=js&"
import style0 from "./CallFeaturesPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports